export default "__VITE_ASSET__Cfa49hXU__"